<template>
  <button @click="getLocation" class="absolute bottom-0 right-0 mr-4 p-2 mb-8 flex justify-center items-center bg-white border border-link rounded-lg shadow-sm">
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>
  </button>
</template>

<script>
export default {
  methods: {
    getLocation: function () {
      if (!navigator.geolocation) {
        alert(this.$t('tour_map_location_error_msg'))
        return
      }
      this.$store.dispatch('geolocation/fetchLocation')
        .then(() => {
          this.$store.dispatch('map/setOffset', true)
          const fromLocation = this.$store.getters['geolocation/getLocation']
          this.$emit('getLocation', fromLocation)
        })
        .catch(() => {
          const errorCode = this.$store.getters['geolocation/getErrorCode']
          this.handleError(errorCode)
        })
    },
    handleError: function (errorCode) {
      switch (errorCode) {
        case 1: //PERMISSION_DENIED
          alert(this.$t('tour_map_denied_err_msg'))
          break
        case 2: //POSITION_UNAVAILABLE
          alert(this.$t('tour_map_position_err_msg'))
          break
        case 3: //TIMEOUT
          alert(this.$t('tour_map_timeout_error_message'))
          break
        default:
          alert(this.$t('tour_map_default_error_message'))
          break
      }
    }
  }
}
</script>
